import { create } from 'zustand';

export type Product = 'grain' | 'beef';

interface ProductState {
  activeProduct: Product;
  setActiveProduct: (product: Product) => void;
}

export const useProductStore = create<ProductState>()((set) => ({
  // Beef View disabled for production - always default to grain
  activeProduct: 'grain' as Product,

  setActiveProduct: (product) => {
    localStorage.setItem('active-product', product);
    set({ activeProduct: product });
  },
}));
